import { render, staticRenderFns } from "./ReceiptDivider.vue?vue&type=template&id=3b3c2d6d&scoped=true&"
import script from "./ReceiptDivider.vue?vue&type=script&lang=js&"
export * from "./ReceiptDivider.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptDivider.vue?vue&type=style&index=0&id=3b3c2d6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3c2d6d",
  null
  
)

export default component.exports